import * as React from 'react';

const Preparing = () => <div>Hang on, we are preparing your payment.</div>;

export default Preparing;
